import React, { useState } from "react";
import { Button, Card, IconButton, TextField } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { PATH, SnackbarType } from "../../constants/appConstants";
import Divider from "@material-ui/core/Divider";
import { SearchOutlined, Delete, PostAdd } from "@material-ui/icons";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Pagination,
  Tooltip,
} from "@mui/material";
import AjaxHelper from "../../apis/apiRequest";
import { Endpoint, Status } from "../../apis/apiConstants";
import { setSnackbar } from "../../reducers/snackbarReducer";
import {
  errorAddJamaat,
  errorAddNotification,
  errorFetchApplicants,
  errorFetchJamaats,
  successAddJamaat,
  successAddNotification,
} from "../../actions/snackbarActions";
import { useDispatch } from "react-redux";
import "./notifications.scss";
import MTextField from "../../components/MTextField";
import MAutocomplete from "../../components/MAutocomplete";
import { getCopy } from "../../helpers/utils.helper";
import { City, Country, State } from "country-state-city";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { useNavigate } from "react-router";
import { isFieldEmpty } from "../../helpers/appFieldValidation";
import NodataComponent from "../../components/NodataComponent";

const formFields = require("./notificationfields.json");

export default function Notifications(props) {
  const [notifications, setNotifications] = useState([]);
  const [notificationPages, setNotificationPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [notification, setNotification] = React.useState({});
  const navigate = useNavigate();
  const [jamaats, setJamaats] = useState([]);

  const [location, setLocation] = useState({
    country: Country.getAllCountries(),
    state: State.getStatesOfCountry("IN"),
    city: City.getCitiesOfState("IN", "MH"),
  });
  const [locationOptions, setLocationOptions] = useState({
    country: {},
    state: {},
    city: {},
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  React.useEffect(() => {
    getJamatList();
    getAllNotifications(1, "");
    getNotificationCount("");
  }, []);

  const getJamatList = () => {
    AjaxHelper.getApi(navigate, Endpoint.GET_JAMAATS)
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          setJamaats(response.data.data);
        } else {
          //   dispatch(errorRegisterUser);
        }
      })
      .catch((err) => {
        // dispatch(errorRegisterUser);
      });
  };
  const getAllNotifications = (page, search) => {
    dispatch(startLoading);
    AjaxHelper.getApi(
      navigate,
      Endpoint.GET_ALL_NOTIFICATIONS,
      {},
      { page, search }
    )
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          setNotifications(response.data.data);
        } else {
          dispatch(
            setSnackbar(true, SnackbarType.ERROR, response.data.message)
          );
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
        dispatch(errorFetchJamaats);
      });
  };

  const changeNotificationStatus = (_id, status) => {
    dispatch(startLoading);
    AjaxHelper.postApi(navigate, Endpoint.CHANGE_NOTIFICATION_STATUS, {
      _id,
      status,
    })
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          getNotificationData();
        } else {
          dispatch(
            setSnackbar(true, SnackbarType.ERROR, response.data.message)
          );
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
      });
  };

  const getNotificationsView = () => {
    return notifications.map((j) => (
      <TableRow>
        <TableCell>
          <span className={"font-medium"}>{j.title}</span>
        </TableCell>
        <TableCell>
          <span className={"font-medium"}>{j.message}</span>
        </TableCell>
        <TableCell>
          <span className={"font-medium"}>
            {isFieldEmpty(j.jamatName) ? "-" : j.jamatName}
          </span>
        </TableCell>
        <TableCell>
          <span className={"font-medium"}>
            {isFieldEmpty(j.country) ? "-" : j.country}
          </span>
        </TableCell>
        <TableCell>
          <span className={"font-medium"}>
            {isFieldEmpty(j.state) ? "-" : j.state}
          </span>
        </TableCell>
        <TableCell>
          <span className={"font-medium"}>
            {isFieldEmpty(j.city) ? "-" : j.city}
          </span>
        </TableCell>
        <TableCell align="center">
          <Tooltip title={j.recStatus === "A" ? "Delete" : "Add"}>
            <IconButton
              onClick={(event) => {
                event.preventDefault();
                changeNotificationStatus(
                  j._id,
                  j.recStatus === "A" ? "D" : "A"
                );
              }}
            >
              {j.recStatus === "A" ? (
                <Delete color={"error"} />
              ) : (
                <PostAdd color={"primary"} />
              )}
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    ));
  };

  const getNotificationCount = (search) => {
    AjaxHelper.getApi(navigate, Endpoint.GET_NOTIFICATION_PAGES, {}, { search })
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          setNotificationPages(response.data.data.pages);
        }
      })
      .catch((error) => {
        // dispatch(errorFetchApplicants);
      });
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
    getAllNotifications(page);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    event.preventDefault();
    let updatedNotification = getCopy(notification);
    updatedNotification[event.target.name] = event.target.value;
    setNotification(updatedNotification);
  };

  const getNotificationFormFields = () => {
    return formFields.map((field) => {
      if (field.type === "text" || field.type === "number") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-12 col-lg-12 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <MTextField
              id={field.key}
              name={field.key}
              className="col-12"
              type={field.type}
              required={field.required}
              label={field.label}
              multiline={field.multiline ?? false}
              value={notification[field.key]}
              onChange={handleChange}
              placeholder={field.placeholder}
            />
          </div>
        );
      } else if (field.type === "jamaat") {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-3 col-lg-6 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <MAutocomplete
              id={field.key}
              size="medium"
              className="input"
              key={field.key}
              inputValue={notification[field.key]}
              required={field.required}
              onChange={(event, newValue) =>
                handleDropdownChange(newValue, field.type)
              }
              options={jamaats}
              placeholder={field.placeholder}
              label={field.label}
            />
          </div>
        );
      } else if (
        field.type === "country" ||
        field.type === "state" ||
        field.type === "city"
      ) {
        return (
          <div
            className={
              (field.size === "half"
                ? "col-xl-6 col-lg-12 col-md-12"
                : "col-xl-3 col-lg-6 col-md-12") +
              "  col-12 d-flex justify-content-center align-items-center"
            }
          >
            <MAutocomplete
              id={field.key}
              value={locationOptions[field.key]}
              key={field.key}
              inputValue={notification[field.key]}
              onInputChange={(event, newInputValue) => {
                const updatedNotification = getCopy(notification);
                updatedNotification[field.key] = newInputValue;
                setNotification(updatedNotification);
              }}
              size="medium"
              className="input"
              required={field.required}
              onChange={(event, newValue) =>
                handleDropdownChange(newValue, field.type)
              }
              options={location[field.type]}
              placeholder={field.placeholder}
              label={field.label}
            />
          </div>
        );
      }
    });
  };

  const getCities = (country, state) => {
    AjaxHelper.getApi(navigate, Endpoint.GET_CITIES, null, {
      state: state,
      country: country,
    })
      .then((response) => {
        if (
          response.data.status === Status.API_SUCCESS ||
          response.data.status === Status.API_NO_CONTENT
        ) {
          let city = City.getCitiesOfState(country, state);
          let newCities = city.concat(response.data.data);
          let updatedLocation = getCopy(location);
          updatedLocation.city = newCities;
          setLocation(updatedLocation);
        } else {
          // dispatch(errorRegisterUser);
        }
      })
      .catch((err) => {
        // dispatch(errorRegisterUser);
      });
  };

  const handleDropdownChange = (value, type) => {
    let updatedNotification = getCopy(notification);
    let updatedLocation = getCopy(location);
    const updatedLocationOptions = getCopy(locationOptions);
    updatedLocationOptions[type] = value;

    let cityApiCalled = false;
    switch (type) {
      case "country":
        updatedNotification.country = value?.name;
        updatedNotification.countryCode = value?.isoCode;
        updatedNotification.state = "";
        updatedNotification.city = "";
        updatedLocation.state = State.getStatesOfCountry(
          updatedNotification.countryCode
        );
        updatedLocation.city = [];
        break;
      case "state":
        updatedNotification.state = value?.name;
        updatedNotification.stateCode = value?.isoCode;
        updatedNotification.city = "";
        updatedLocation.city = [];
        cityApiCalled = true;
        break;
      case "city":
        updatedNotification.city = value?.name;
        break;
      case "jamaat":
        updatedNotification.jamatName = value?.name;
        updatedNotification.jamatCode = value?.code;
        break;
      default:
        break;
    }
    setNotification(updatedNotification);
    setLocation(updatedLocation);
    setLocationOptions(updatedLocationOptions);
    if (cityApiCalled) {
      getCities(updatedNotification.countryCode, updatedNotification.stateCode);
    }
  };

  const addNotification = () => {
    console.log("Add clicked");
    handleClose();
    dispatch(startLoading);
    AjaxHelper.postApi(navigate, Endpoint.ADD_NOTIFICATION, notification)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_CREATED) {
          dispatch(successAddNotification);
          getNotificationData();
        } else if (response.data.status === Status.API_SUCCESS) {
          const successMessage = successAddJamaat;
          successMessage.snackbarMessage = response.data.message;
          dispatch(successMessage);
          getNotificationData();
        } else {
          dispatch(errorAddNotification);
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorAddNotification);
      });
  };

  const getNotificationData = () => {
    getAllNotifications(searchText.length > 0 ? 1 : currentPage, searchText);
    getNotificationCount(searchText);
  };

  return (
    <div className={"notification-component d-flex flex-column p-md-3"}>
      <div className="d-flex flex-row align-items-center justify-content-between p-md-0 p-3">
        <div className="d-flex flex-row justify-content-center align-content-center">
          <TextField
            fullWidth
            value={searchText}
            placeholder="Search"
            onKeyDown={(event) => {
              if (event.keyCode === 13) {
                getNotificationData();
              }
            }}
            onChange={(event) => {
              setSearchText(event.target.value);
            }}
            InputProps={{
              endAdornment: (
                <IconButton onClick={() => getNotificationData()}>
                  <SearchOutlined />
                </IconButton>
              ),
            }}
          />
          <Button
            variant={"text"}
            className="button"
            onClick={() => {
              setSearchText("");
              getAllNotifications(1, "");
              getNotificationCount("");
            }}
          >
            Reset
          </Button>
        </div>
        <Button
          variant="contained"
          className="button"
          color="primary"
          onClick={() => {
            setNotification({});
            setLocationOptions({});
            handleClickOpen();
          }}
        >
          Add
        </Button>
      </div>
      <Card className="innerCard mt-3 " variant="outlined">
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow className={"background-color-head"}>
                <TableCell>
                  <span className={"font-bold font-18"}>Title</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Message</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Jamaat</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>Country</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>State</span>
                </TableCell>
                <TableCell>
                  <span className={"font-bold font-18"}>City</span>
                </TableCell>
                <TableCell align="center">
                  <span className={"font-bold font-18"}>Action</span>
                </TableCell>
              </TableRow>
            </TableHead>
            {getNotificationsView()}
          </Table>
        </TableContainer>
        {notifications.length > 0 ? null : <NodataComponent />}
        {notificationPages > 0 ? (
          <Pagination
            className={"mpagination"}
            count={notificationPages}
            variant="outlined"
            shape="rounded"
            onChange={(event, page) => onPageChange(page)}
          />
        ) : null}
      </Card>

      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogTitle className={"background-color-head"}>
          <span className={"font-bold font-18"}>Notification form</span>
        </DialogTitle>
        <Divider />

        <div className={"jamaat-form"}>{getNotificationFormFields()}</div>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            onClick={() => {
              addNotification();
              console.log("trigged");
            }}
          >
            {"Add"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
